import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import { Input } from '@mui/material';

export default function ExamVerification() {
  const navigate = useNavigate();
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }
  const tableRef = useRef(null);
  const collegename = localStorage.getItem('username');
  const [flag, setflag] = useState(false);
  const [tableData, setTableCountData] = useState([]);
  const [loading, setlodaing] = useState(false);
  const [examid, setExamIdData] = useState('');
  const [getexamData, setExamData] = useState([]);

  const { http } = Api();
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),

    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await http.get(`College/getHallticketAtiveExam`);
        setExamData(response.data);
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error("No active exam found");
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };
    fetchExamData();
  }, []);

  const handlExamChange = async (selectedOption) => {
    const examId = selectedOption.value;
    setExamIdData(selectedOption.value);
    try {
      const response = await http.get(`College/getCollegeRegistrationcount`,
        { params: { examid: examId } }
      );
      console.log("response==", response);
      setTableCountData(response.data);
    }
    catch (error) {
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);

      }
      else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
        toast.error(error.response.data.message);
      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
        toast.error("No active exam found");
      }
      else {
        toast.error("Something went wrong");
      }
    }
  };

  const handleGenerateHallticketPDF = async (examid, disciplineId, disciplineName, courseType) => {
    setlodaing(true);
    try {
      const response = await http.get('/College/generateHallticket', {
        params: {
          examid: examid,
          discipline_id: disciplineId,
          college_course_type: courseType
        },
        responseType: 'blob',
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute('download', `${localStorage.getItem('username')}_${disciplineName}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setlodaing(false);
        return Promise.resolve('PDF generated successfully');
      }

    } catch (error) {
      setlodaing(false);
      console.error('Error generating PDF:', error);
      return Promise.reject('Error generating PDF');

    }
  };

  const handleGenerateNominalRolePDF = async (examid, disciplineId, disciplineName, courseType) => {
    setlodaing(true);
    try {
      const response = await http.get('/College/generateNominalRoll', {
        params: {
          examid: examid,
          discipline_id: disciplineId,
          college_course_type: courseType
        },
        responseType: 'blob',
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute('download', `${localStorage.getItem('username')}_${disciplineName}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setlodaing(false);

        return Promise.resolve('PDF generated successfully');
      }
    } catch (error) {
      setlodaing(false);
      console.error('Error generating PDF:', error);
      return Promise.reject('Error generating PDF');
    }
  };



  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (


          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="my-page">

            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Halltickets/Nominal Roll</h5>
                        </div>

                      </div>
                      <div className="card-body">

                        <div className="card-body pdg">
                          <div className="">
                            <div className="form theme-form tab-out-bod">
                              <div className="card-body custom-input">
                                <div className="row">
                                  <div className="col-md-12">
                                    <label>Exam<span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="exam_id"
                                      name="exam_id"
                                      styles={customStyles}

                                      className="basic-select"
                                      classNamePrefix="select"
                                      options={getexamData.map(exam => ({
                                        value: exam.examid,
                                        label: exam.examtitle
                                      }))}
                                      onChange={handlExamChange}
                                      placeholder="Select a semester exam..."
                                    />
                                  </div>
                                </div>

                                <div className="txt-aln-jst m-10">
                                  {/* <p>
                                  <span className="text-danger">Note: This page is intended to track the status of students, whether they have completed the course registration process or not. It is not meant for verifying the course registrations made by students. Verification should only be carried out after the student portal has closed. Please note that students can modify their course selections up until the portal's closing time.
                                  </span>
                                  </p> */}
                                </div>



                                <div class="table-containerq" style={{ overflowX: 'unset' }}>
                                  <div className="table-responsive">

                                    <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef} id="dataTable">
                                      <thead>
                                        <tr className="bg-primary">

                                          <th scope="col" data-label="APAAR Id" width="8%">Sl No</th>
                                          <th scope="col" data-label="Programme" width="">Programme</th>
                                          <th scope="col" data-label="Total Student Count" width="">Total Student Count</th>

                                          <th scope="col" data-label="Registered Count" width="">Registered Count</th>
                                          <th scope="col" data-label="Principal Approved Count" width="">Principal Approved Count</th>
                                          <th scope="col" data-label="Hallticket" width="">Hallticket</th>
                                          <th scope="col" data-label="Nominal Roll" width="">Nominal Roll</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {tableData.length > 0 ? (
                                          tableData.map((item, index) => (
                                            <tr key={item.discipline_id}>
                                              <td data-label="Sl No.">{index + 1}</td>
                                              <td data-label="Programme">{item.discipline_name}</td>
                                              <td data-label="Total Student Count">{item.student_count}</td>
                                              <td data-label="Registered Count">{item.registration_count}</td>
                                              <td data-label="Principal Approved Count">{item.principalapproved}</td>
                                              <td data-label="Hallticket" ><div className="txt-aln" style={{ cursor: 'pointer' }}><i className="fa fa-print tab-icn-clr icn-out-bod" aria-hidden="true"
                                                onClick={() => handleGenerateHallticketPDF(examid, item.discipline_id, item.discipline_name, item.college_course_type)} title="Downlod"></i></div></td>
                                              <td data-label="Nominal Roll"><div className="txt-aln" style={{ cursor: 'pointer' }}><i className="fa fa-print icn-out-bod" aria-hidden="true"
                                                onClick={() => handleGenerateNominalRolePDF(examid, item.discipline_id, item.discipline_name, item.college_course_type)} title="Nominal Roll"></i></div></td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="7" className="text-center">No data found</td>
                                          </tr>
                                        )}

                                      </tbody>
                                    </table>


                                  </div>
                                </div>

                              </div>


                            </div>



                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


      </Template>
    </>
  );
}
